<img class="favrit-logo" src="../../../../assets/favrit_logo_positive_rbg.svg" alt="Favrit logo" />
